"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _reactRouter = require("react-router");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _AlertBox = _interopRequireDefault(require("../../../domainless/feedback/AlertBox"));
var _validator = _interopRequireDefault(require("../../../../utils/validator"));
var _validationConstraints = require("./validationConstraints");
var _SNETLoginModule = _interopRequireDefault(require("./SNETLogin.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SNETLogin = props => {
  const {
    title,
    forgotPasswordLink,
    onSubmit,
    loginError
  } = props;
  const [email, setEmail] = (0, _react.useState)("");
  const [password, setPassword] = (0, _react.useState)("");
  const [validationErr, setValidationErr] = (0, _react.useState)("");
  const handleSubmit = event => {
    event.preventDefault();
    event.stopPropagation();
    const isNotValid = (0, _validator.default)({
      email,
      password
    }, _validationConstraints.validationConstraints);
    if (isNotValid) {
      setValidationErr(isNotValid[0]);
      return;
    }
    onSubmit(email, password);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _SNETLoginModule.default.loginDetails
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h2"
  }, title), /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true,
    autoComplete: "off",
    className: _SNETLoginModule.default.loginForm
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    id: "outlined-user-name",
    label: "Email",
    className: _SNETLoginModule.default.textField,
    margin: "normal",
    variant: "outlined",
    value: email,
    autoFocus: true,
    onChange: e => setEmail(e.target.value.toLowerCase())
  }), /*#__PURE__*/_react.default.createElement(_TextField.default, {
    id: "outlined-password-input",
    label: "Password",
    className: _SNETLoginModule.default.textField,
    type: "password",
    autoComplete: "current-password",
    margin: "normal",
    variant: "outlined",
    value: password,
    onChange: e => setPassword(e.target.value)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _SNETLoginModule.default.checkboxAndLink
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SNETLoginModule.default.checkBox
  }), /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
    to: forgotPasswordLink
  }, "Forgot password?")), /*#__PURE__*/_react.default.createElement(_AlertBox.default, {
    type: "error",
    message: validationErr || loginError
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: "primary",
    variant: "contained",
    children: "login",
    type: "submit",
    onClick: handleSubmit
  })));
};
SNETLogin.propTypes = {
  title: _propTypes.default.string,
  forgotPasswordLink: _propTypes.default.string,
  loginError: _propTypes.default.string,
  onSubmit: _propTypes.default.func
};
var _default = exports.default = SNETLogin;